import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface ScrapeAthleticNetMeetRequest {
    url: string;
    group_uuid: string;
}

interface ScrapeAthleticNetMeetResponse {
    job_id: string;
    status: string;
    message: string;
}

type ReturnType = Promise<AxiosResponse<ScrapeAthleticNetMeetResponse>>;

const scrapeAthleticNetMeet = (data: ScrapeAthleticNetMeetRequest): ReturnType => {
    return Request.post('/workouts/track-events/scrape-athletic-net-meet', data);
};

export default scrapeAthleticNetMeet;
